// Angular
import { Component, Input, OnInit } from '@angular/core'
// NGRX
import { select, Store } from '@ngrx/store'
// RxJS
import { Observable } from 'rxjs'
import { currentUser, Logout, User } from '../../../../../../core/auth'
// State
import { AppState } from '../../../../../../core/reducers'
//Services
import { StateService,ConnectionService,TiersService,DialogService } from '../../../../../../services' 
import { ModifUserDialog } from '../../../../content/actions/modif-user-dialog/modif-user-dialog.component';
import { environment } from "../../../../../../../environments/environment"



@Component({
	selector: 'atyl-user-profile-info',
	templateUrl: './user-profile-info.component.html',
	styleUrls: ['./user-profile-info.component.scss']
})
export class UserProfileModifComponent implements OnInit {
	// Public properties

	@Input() showAvatar: boolean = true;
	@Input() showHi: boolean = true;
	@Input() showBadge: boolean = false;
    @Input() user: any;
    @Input() userDroits: any;
	/**
	 * Component constructor
	 *
	 * @param store: Store<AppState>
	 */
	constructor(
		private store: Store<AppState>,
		private stateService: StateService,
		private conecctionService: ConnectionService,
        private tiersService: TiersService,
        private dialogService: DialogService
		) {
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit(): void {
	}
}
